import { CartNumberInput, NumberTypeEnum } from '@/types/generated/graphql';
import { PurchaseNumberEdge } from '@modules/settings/my-numbers/purchase-number/purchase-number.types';

export type ClaimNumberSelection = {
  phoneNumber: string;
  friendlyName: string;
  row: PurchaseNumberEdge;
};

export function buildClaimCartNumbers(selections: ClaimNumberSelection[], capabilities: string[]): CartNumberInput[] {
  return selections.map(({ phoneNumber, friendlyName, row }) => ({
    friendlyName,
    phoneNumber,
    numberType: row?.numberType as NumberTypeEnum,
    isoCountry: row?.isoCountry ?? '',
    addressRequirements: row?.addressRequirements ?? '',
    basePrice: row?.basePrice,
    capabilities: {
      MMS: capabilities?.includes('MMS') ?? false,
      SMS: capabilities?.includes('SMS') ?? false,
      voice: capabilities?.includes('voice') ?? false,
    },
    currentPrice: row?.currentPrice,
    rateCenter: row?.rateCenter,
    region: row?.region,
  }));
}
